import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PERMISSIONGROUPS } from '../../../../core/models/permission.model';
import { ResultStatus, RouterUtil } from '@seahorse/common';
import { IdentityService } from '../../../../core/services/identity.service';
import { NotificationService } from '@seahorse/common';
import { UserDataService } from '../../../../user/services/user-data.service';
import { SeahorseAccountService } from '../../services/user-account.service';
import { Guid } from 'guid-typescript';
import { CreateEnvironmentComponent } from '../create-environment/create-environment.component';
import { OrganisationModel } from '@seahorse/domain';

@Component({
  selector: 'ca-set-permissions',
  templateUrl: './set-permissions.component.html',
  standalone: false,
})
export class SetPermissionsComponent implements OnInit {
  @ViewChild(CreateEnvironmentComponent)
  createEnvironmentComponent: CreateEnvironmentComponent;

  permissions = PERMISSIONGROUPS;
  isLoading = false;
  hasStartedCreatingEnvironment = false;
  somethingWentWrong = false;
  seedOrganizations: OrganisationModel[] = [];
  selectedOrganisationId: Guid;

  constructor(
    private routerUtil: RouterUtil,
    private userDataService: UserDataService,
    private notificationService: NotificationService,
    private router: Router,
    private translateService: TranslateService,
    private identityService: IdentityService,
    private userAccountService: SeahorseAccountService
  ) {}

  ngOnInit() {
    this.routerUtil.currentModuleName = this.translateService.instant(
      'account.register.permissions.title'
    );

    this.userAccountService
      .getDemoOrganisations()
      .subscribe((organisations) => {
        this.seedOrganizations = organisations.result;
      });
  }

  save() {
    this.isLoading = true;
    this.hasStartedCreatingEnvironment = true;
    this.somethingWentWrong = false;

    this.createEnvironmentComponent.createEnvironment().subscribe(
      (environmentCreated) => {
        if (!environmentCreated) {
          this.isLoading = false;
          this.somethingWentWrong = true;
          return;
        }

        const permissionNames = this.permissions
          .filter((x) => x.checked)
          .map((x) => x.name);

        this.userDataService.setPermissions(permissionNames).subscribe(
          (result) => {
            if (result.status === ResultStatus.OK) {
              this.notificationService.showSuccess(
                'Permissions added!',
                'Successfully'
              );

              this.identityService.identity = result.result.user;
              this.identityService.setPermissions(result.result.permissions);

              this.router.navigate(['/dashboard']);
              window.location.reload();
            } else {
              this.notificationService.showError(
                'Something went wrong!',
                'Failed'
              );
              this.isLoading = false;
              this.somethingWentWrong = true;
            }
          },
          () => {
            this.isLoading = false;
            this.somethingWentWrong = true;
          }
        );
      },
      () => {
        this.isLoading = false;
        this.somethingWentWrong = true;
      }
    );
  }
}
